// FILE: frontend/src/components/ReviewView.jsx
// Score review pager — step through each scored turn (Patricia's design)

import React from 'react'
import ScoreBar from './ScoreBar'

export default function ReviewView({ scores, transcript, index, setIndex, onDone }) {
  const total = Array.isArray(scores) ? scores.length : 0
  const userTurns = Array.isArray(transcript) ? transcript.filter(m => m?.speaker === 'user') : []

  const safeIdx = Math.min(Math.max(index || 0, 0), Math.max(total - 1, 0))
  const score = (scores && scores[safeIdx]) || {}

  const scoreUser = (typeof score.user_text === 'string' ? score.user_text : '').trim()
  const transcriptUser = (userTurns[safeIdx]?.text || '').trim()
  const userUtterance = scoreUser || transcriptUser || '(no transcript captured for this turn)'

  const goPrev = () => setIndex(i => Math.max(0, (i ?? 0) - 1))
  const goNext = () => setIndex(i => Math.min(total - 1, (i ?? 0) + 1))

  return (
    <div className="sqa-review">
      <div className="sqa-review-header">
        <h1>Review Your Scores</h1>
        <p>Turn {safeIdx + 1} of {Math.max(total, 1)}</p>
      </div>

      {total === 0 ? (
        <div className="sqa-empty-state">No scores recorded.</div>
      ) : (
        <div className="sqa-review-card">
          {/* User utterance */}
          <div className="sqa-review-section">
            <h3>Your Answer</h3>
            <div className="sqa-utterance-box">{userUtterance}</div>
          </div>

          {/* Score breakdown */}
          <div className="sqa-review-section">
            <h3>Feedback</h3>
            <div className="sqa-review-score-row">
              <div className="sqa-review-score-circle">
                <div className="sqa-review-score-num">{Number(score.overall ?? 0)}</div>
                <div className="sqa-review-score-label">/100</div>
              </div>
              <div className="sqa-review-bars">
                <ScoreBar label="Intent Match" value={score.intent_match} />
                <ScoreBar label="Fluency" value={score.fluency} />
                <ScoreBar label="Completeness" value={score.completeness} />
                <ScoreBar label="Vocabulary" value={score.vocabulary} />
              </div>
            </div>
            {score.justification && (
              <div className="sqa-review-justification">{String(score.justification)}</div>
            )}
          </div>

          {/* Navigation */}
          <div className="sqa-review-nav">
            <button
              className="sqa-btn sqa-btn-secondary"
              onClick={goPrev}
              disabled={safeIdx === 0}
            >
              ← Previous
            </button>
            <button
              className="sqa-btn sqa-btn-secondary"
              onClick={goNext}
              disabled={safeIdx >= total - 1}
            >
              Next →
            </button>
            <button
              className="sqa-btn sqa-btn-primary"
              onClick={onDone}
            >
              Back to Summary
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
